var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.$t('message.password'))+" "),_c('div',{staticClass:"flix-html-h1",staticStyle:{"font-family":"monospace","margin-top":"0"}},[_vm._v(_vm._s(_vm.password))])])
}
var staticRenderFns = []

export { render, staticRenderFns }